import React from "react";
import { useHistory, useParams } from "react-router-dom";

import { KintoneExportReportDetailContent } from "../../../../organisms/kintone-export/kintone-export-report-detail-content";
import { ServiceProviderTemplate } from "../../../../template/service-provider/default-template";
import { useKintoneExportReportDetailPage } from "../../../data-transfer/kintone-export/page-hooks/kintone-export-report-detail/hook";
import { useReExportErrorSubmission } from "../../../data-transfer/kintone-export/page-hooks/kintone-export-report-detail/hook";
import { KintoneExportR } from "../../../data-transfer/kintone-export/routes";
import { KintoneExportOrgProductAssertion } from "./plugin/kintone-export-org-product-assertion-plugin";
import { ServiceProviderR } from "../../routes";
import type { KintoneExportReport } from "@graffer-inc/cloud-gov-core";
import { useManualExportSubmission } from "../../../../organisms/kintone-export/common-hook";

type PageParam = {
  tenantId: string;
  kintoneExportSettingId: string;
  reportId: string;
};

export const KintoneExportReportDetailPage: React.FC = () => {
  const { tenantId, kintoneExportSettingId, reportId } = useParams<PageParam>();

  const { pageContent } = useKintoneExportReportDetailPage({
    kintoneExportSettingId,
    kintoneExportReportId: reportId,
  });

  const history = useHistory();
  const moveToReportDetail = React.useCallback(
    (kintoneExportReportId: KintoneExportReport["id"]) => {
      history.push(
        KintoneExportR.KintoneExportReportDetail.link({
          kintoneExportSettingId,
          kintoneExportReportId,
        }),
      );
    },
    [history, kintoneExportSettingId],
  );

  const { manualExportSubmission } = useManualExportSubmission();

  const { reExportErrorSubmission, isReExporting } = useReExportErrorSubmission(
    {
      manualExportSubmission,
      moveToReportDetail,
    },
  );

  return (
    <>
      <KintoneExportOrgProductAssertion />
      <ServiceProviderTemplate
        breadcrumbs={[
          {
            to: ServiceProviderR.Home.link({}),
            title: "Home",
          },
          {
            to: ServiceProviderR.DataTransferTop.link({ tenantId }),
            title: "データ連携",
          },
          {
            to: ServiceProviderR.KintoneExportSettings.link({ tenantId }),
            title: "スマート申請の申請データを kintone へ転送",
          },
          {
            to: ServiceProviderR.KintoneExportSettingDetail.link({
              tenantId,
              kintoneExportSettingId,
            }),
            title:
              pageContent?.kintoneExportSetting.name ?? kintoneExportSettingId,
          },
          {
            to: ServiceProviderR.KintoneExportReportDetail.link({
              tenantId,
              kintoneExportSettingId,
              reportId,
            }),
            title: `実行記録#${reportId}`,
          },
        ]}
      >
        {!!pageContent && (
          <KintoneExportReportDetailContent
            kintoneExportReport={pageContent.kintoneExportReport}
            kintoneExportSetting={pageContent.kintoneExportSetting}
            reExportErrorSubmission={reExportErrorSubmission}
            isReExporting={isReExporting}
          />
        )}
      </ServiceProviderTemplate>
    </>
  );
};
